export const BASE_URL = 'https://gocantik.labnesia.com'
// export const BASE_URL = 'http://localhost:3000'

export const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
export const months = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]